import { render, staticRenderFns } from "./AppMakeReferralMenu.vue?vue&type=template&id=2aebb0a0"
import script from "./AppMakeReferralMenu.vue?vue&type=script&lang=js"
export * from "./AppMakeReferralMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMakeReferralMenu.vue?vue&type=style&index=0&id=2aebb0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports